<div class="no-data-found">
  {{ message |translate }}
</div>
